import React from 'react';
import {formatPrice} from 'shared/helpers';
import MinimumUsageMoreInfo from 'shared/components/Header/MinimumUsageMoreInfo';
import {MoreInfoStatic} from 'shared/components/MoreInfo/MoreInfo';
import {useMapMaterialDisplayName} from 'shared/components/Header/helper/useMapMaterialDisplayName';
import {useMinUsageInfo} from 'shared/components/Header/helper/useMinUsageInfo';

export const MinimumUsageFee = () => {
    const {mapMaterialDisplayName} = useMapMaterialDisplayName();
    const {manufacturerEditMinMatUsage, totalMinUsage, moreInfoData} =
        useMinUsageInfo();

    if (manufacturerEditMinMatUsage) {
        if (totalMinUsage > 0) {
            // manufacturer edit the min usage and set it to a custom value
            return (
                <li>
                    <span style={{display: 'flex'}}>Minimum Usage Fee: </span>
                    <span>{formatPrice(totalMinUsage, {})}</span>
                </li>
            );
        }
    }

    if (
        moreInfoData.benchtopMaterial.length == 0 &&
        moreInfoData.cabinetMaterial.length == 0
    ) {
        return null;
    }

    return (
        <li>
            <span style={{display: 'flex'}}>
                Minimum Usage Fee:{' '}
                <MoreInfoStatic
                    editbuttonVisible={false}
                    hoverText="Minimum Usage Fee"
                    dialogClassName="modal-md"
                    info={
                        <MinimumUsageMoreInfo
                            minimumUsages={moreInfoData}
                            mapMaterialDisplayName={mapMaterialDisplayName}
                        />
                    }
                />
            </span>

            <span>{formatPrice(totalMinUsage, {})}</span>
        </li>
    );
};
